var _circle, _g, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "rta31kmsba",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 74.5,
    fill: "#D9D9D9",
    stroke: "#E4E7EB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#rta31kmsba)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 39.5,
    width: 83,
    height: 115,
    rx: 3.5,
    fill: "#EDF5FF",
    stroke: "#C6D8EE",
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.007 48H82.993C80.788 48 79 49.859 79 52.152v31.696C79 86.141 80.788 88 82.993 88h19.014c2.205 0 3.993-1.859 3.993-4.152V52.152c0-2.293-1.788-4.152-3.993-4.152zM67.007 96H47.993C45.788 96 44 97.859 44 100.152v31.696c0 2.293 1.788 4.152 3.993 4.152h19.014c2.205 0 3.993-1.859 3.993-4.152v-31.696C71 97.859 69.212 96 67.007 96z",
    fill: "#DAE9FD",
    stroke: "#C6D8EE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.387 43.774a3.387 3.387 0 1 0 0-6.774 3.387 3.387 0 0 0 0 6.774zM116.387 43.774a3.387 3.387 0 1 0 0-6.775 3.387 3.387 0 0 0 0 6.775z",
    fill: "#B1CAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.393 48H47.6c-1.986 0-3.596 1.675-3.596 3.74v32.52c0 2.065 1.61 3.74 3.596 3.74h19.794c1.987 0 3.597-1.675 3.597-3.74V51.74c0-2.065-1.61-3.74-3.597-3.74z",
    fill: "#6EA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.05 60.79v-4.1c0-1.577 1.23-2.847 2.738-2.847h9.729c1.516 0 2.737 1.279 2.737 2.847v4.1M44 60.414h27",
    stroke: "#E4EEF9",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 106,
    r: 23,
    fill: "#6EA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.297 105.297h-7.594v-7.594a.703.703 0 0 0-1.406 0v7.594h-7.594a.703.703 0 0 0 0 1.406h7.594v7.594a.703.703 0 0 0 1.406 0v-7.594h7.594a.703.703 0 0 0 0-1.406z",
    fill: "#fff",
    stroke: "#fff"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 74.5,
    stroke: "#E4E7EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/Graphic.8096395f.svg";
export { ForwardRef as ReactComponent };